module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("ch38V"))).then(() => parcelRequire('fl4My'));